import React from "react";
import { Link } from "react-router-dom";
export const RoundDataColumnFormatter = (value) => {
    // console.log(row.contest, row.contestIds) //
    return <>
        <span className="d-block">Rank : {value.rank || 0}
        </span><span className="d-block">Points : {value.points || 0}</span>
        <span className="d-block">Kills : {value.kills || 0}</span>
    </>;
}
